(function () {
  function buildSectionUrl(url, sectionId) {
    const nextUrl = new URL(url, window.location.origin);
    nextUrl.searchParams.set('section_id', sectionId);
    return nextUrl.toString();
  }

  function buildPageUrl(url) {
    const nextUrl = new URL(url, window.location.origin);
    nextUrl.searchParams.delete('section_id');
    return `${nextUrl.pathname}${nextUrl.search}`;
  }

  function getSection(root) {
    return root.matches('[data-collection-products]')
      ? root
      : root.querySelector('[data-collection-products]');
  }

  async function fetchSection(section, url) {
    const sectionId = section.dataset.sectionId;
    const response = await fetch(buildSectionUrl(url, sectionId), { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Failed to load collection');
    return response.text();
  }

  function parseSection(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-collection-products]');
  }

  function replacePanel(section, fetchedSection) {
    const panel = section.querySelector('[data-collection-products-panel]');
    const fetchedPanel = fetchedSection?.querySelector('[data-collection-products-panel]');
    if (panel && fetchedPanel) {
      panel.replaceWith(fetchedPanel);
    }
  }

  function updateHistory(url) {
    window.history.pushState({ collectionProducts: true }, '', buildPageUrl(url));
  }

  function closePanel(section, panelName) {
    const panel = section.querySelector(`[data-collection-${panelName}-panel]`);
    const trigger = section.querySelector(`[data-collection-toggle-${panelName}]`);
    if (!panel) return;

    panel.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.classList.remove('is-active');
  }

  function togglePanel(section, panelName) {
    const panel = section.querySelector(`[data-collection-${panelName}-panel]`);
    const trigger = section.querySelector(`[data-collection-toggle-${panelName}]`);
    if (!panel) return;

    const willOpen = panel.hidden;
    closePanel(section, 'filters');
    closePanel(section, 'sort');

    if (willOpen) {
      panel.hidden = false;
      trigger?.setAttribute('aria-expanded', 'true');
      trigger?.classList.add('is-active');
    }
  }

  async function submitFilters(section, form) {
    if (!form) return;

    const url = new URL(form.action || window.location.pathname, window.location.origin);
    url.search = new URLSearchParams(new FormData(form)).toString();
    await refreshCollection(section, url.toString());
  }

  async function applySort(section, sortValue) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    url.searchParams.delete('page');
    await refreshCollection(section, url.toString());
  }

  async function refreshCollection(section, url) {
    section.classList.add('is-loading');

    try {
      const html = await fetchSection(section, url);
      const fetchedSection = parseSection(html);
      replacePanel(section, fetchedSection);
      updateHistory(url);
    } finally {
      section.classList.remove('is-loading');
    }
  }

  function clearFilters(section) {
    const form = section.querySelector('[data-collection-filters-form]');
    if (!form) return;

    form.querySelectorAll('[data-collection-filter-input]').forEach((input) => {
      if (input.type === 'checkbox') {
        input.checked = false;
      } else {
        input.value = '';
      }
    });
  }

  async function loadMore(section, loadMoreBtn) {
    const nextUrl = loadMoreBtn.dataset.nextUrl;
    if (!nextUrl || loadMoreBtn.disabled) return;

    loadMoreBtn.disabled = true;

    try {
      const html = await fetchSection(section, nextUrl);
      const fetchedSection = parseSection(html);
      const grid = section.querySelector('[data-collection-grid]');
      const fetchedGrid = fetchedSection?.querySelector('[data-collection-grid]');
      const fetchedFooter = fetchedSection?.querySelector('[data-collection-footer]');
      const footer = section.querySelector('[data-collection-footer]');

      if (grid && fetchedGrid) {
        fetchedGrid.querySelectorAll('[data-collection-product-card]').forEach((card) => {
          grid.appendChild(card);
        });
      }

      if (footer && fetchedFooter) {
        footer.replaceWith(fetchedFooter);
      }
    } catch {
      loadMoreBtn.disabled = false;
    }
  }

  function bindCollectionProducts(section) {
    if (section.dataset.collectionBound === 'true') return;

    section.dataset.collectionBound = 'true';

    section.addEventListener('click', async (event) => {
      if (event.target.closest('[data-collection-toggle-filters]')) {
        event.preventDefault();
        togglePanel(section, 'filters');
        return;
      }

      if (event.target.closest('[data-collection-toggle-sort]')) {
        event.preventDefault();
        togglePanel(section, 'sort');
        return;
      }

      const sortOption = event.target.closest('[data-collection-sort-option]');
      if (sortOption) {
        event.preventDefault();
        closePanel(section, 'sort');
        await applySort(section, sortOption.dataset.collectionSortOption);
        return;
      }

      if (event.target.closest('[data-collection-apply-filters]')) {
        event.preventDefault();
        closePanel(section, 'filters');
        await submitFilters(section, section.querySelector('[data-collection-filters-form]'));
        return;
      }

      if (event.target.closest('[data-collection-clear-filters]')) {
        event.preventDefault();
        clearFilters(section);
        closePanel(section, 'filters');
        await submitFilters(section, section.querySelector('[data-collection-filters-form]'));
        return;
      }

      const loadMoreBtn = event.target.closest('[data-load-more]');
      if (loadMoreBtn) {
        event.preventDefault();
        await loadMore(section, loadMoreBtn);
      }
    });

    section.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePanel(section, 'filters');
        closePanel(section, 'sort');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-collection-products]').forEach(bindCollectionProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-collection-products]');
    if (section) {
      delete section.dataset.collectionBound;
      bindCollectionProducts(section);
    }
  });

  window.addEventListener('popstate', () => {
    const section = document.querySelector('[data-collection-products]');
    if (!section) return;
    refreshCollection(section, window.location.href);
  });
})();
